import {
  ExclamationCircleIcon,
  TrashIcon,
  XMarkIcon,
} from "@heroicons/react/20/solid";
import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Tooltip } from "react-tooltip";

function DeleteConfirmation({ id_crypt, apiType, fetchClientData, type }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [dialogForTransaction, setDialogForTransaction] = useState(false);
  const [employeesDataList, setEmployeesDataList] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");

  const openDialog = (id_crypt) => {
    setCurrentProjectId(id_crypt);
    setIsDialogOpen(true);
  };

  const closeDialog = () => {
    setIsDialogOpen(false);
    setCurrentProjectId(null);
  };

  const handleDeleteForTask = async () => {
    setIsDialogOpen(false);
    const token = localStorage.getItem("token");
    try {
      const apiUrl = `public/api/admin/employees/pagination`;

      const responseForEmployee = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setEmployeesDataList(responseForEmployee.data.employees.data);

      let endpoint = "";
      if (apiType === "task") {
        endpoint = `public/api/admin/client_project_task/delete/${currentProjectId}`;
      } else if (apiType === "project") {
        endpoint = `public/api/admin/client_project/delete/${currentProjectId}`;
      } else if (apiType === "product") {
        endpoint = `public/api/admin/product/delete/${currentProjectId}`;
      } else if (apiType === "vendor") {
        endpoint = `public/api/admin/vendor/delete/${currentProjectId}`;
      } else if (apiType === "sales") {
        endpoint = `public/api/admin/clientsales/delete/${currentProjectId}`;
      } else if (apiType === "purchase") {
        endpoint = `public/api/admin/purchase/delete/${currentProjectId}`;
      } else if (apiType === "device") {
        endpoint = `public/api/admin/device/delete/${currentProjectId}`;
      } else if (apiType === "dealer") {
        endpoint = `public/api/admin/dealer/delete/${currentProjectId}`;
      } else if (apiType === "customer") {
        endpoint = `public/api/admin/customer/delete/${currentProjectId}`;
      } else if (apiType === "payment") {
        endpoint = `public/api/admin/payment_mode/delete/${currentProjectId}`;
      } else if (apiType === "bill_type") {
        endpoint = `public/api/admin/bill_type/delete/${currentProjectId}`;
      } else if (apiType === "product_type") {
        endpoint = `public/api/admin/product_type/delete/${currentProjectId}`;
      } else if (apiType === "code_type") {
        endpoint = `public/api/admin/code_type/delete/${currentProjectId}`;
      } else if (apiType === "lead") {
        endpoint = `public/api/admin/lead/delete/${currentProjectId}`;
      } else if (apiType === "leadSource") {
        endpoint = `public/api/admin/leadsource/delete/${currentProjectId}`;
      } else if (apiType === "leadStatus") {
        endpoint = `public/api/admin/leadstatus/delete/${currentProjectId}`;
      }else if (apiType === "quotationStatus") {
        endpoint = `public/api/admin/quotationstatus/delete/${currentProjectId}`;
      } 
      else if (apiType === "lead_task") {
        endpoint = `public/api/admin/tasks/delete/${currentProjectId}`;
      } else if (apiType === "taskStatus") {
        endpoint = `public/api/admin/taskstatus/delete/${currentProjectId}`;
      } 
      else if (apiType === "quotation") {
        endpoint = `public/api/admin/quotation/delete/${currentProjectId}`;
      } else if (apiType === "employee") {
        endpoint = `public/api/admin/employees/delete/${currentProjectId}`;
      } else if (apiType === "role") {
        endpoint = `public/api/admin/leadrole/delete/${currentProjectId}`;
      } else if (apiType === "roleassign") {
        endpoint = `public/api/admin/leadroleassign/delete/${currentProjectId}`;
      } else if (apiType === "taskDiscussionStatus") {
        endpoint = `public/api/admin/taskdiscussionstatus/delete/${currentProjectId}`;
      } else if (apiType === "branch") {
        endpoint = `public/api/admin/branch/delete/${currentProjectId}`;
      } else if (apiType === "product") {
        endpoint = `public/api/admin/product/delete/${currentProjectId}`;
      } else if (apiType === "typeOfWork") {
        endpoint = `public/api/admin/type-of-work/${currentProjectId}`;
      }

      const response = await axios.delete(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
   

      if (response.data.branch?.branch_delete_status === 1) {
        setDialogForTransaction(true);
        setErrorMessage(response.data.message);
      } else if (response.data.product?.delete_status === 1) {
        setDialogForTransaction(true);
        setErrorMessage(response.data.message);
      } else {
        setDialogForTransaction(false);
        toast.success(response.data.message);
      }

      if (apiType === "project" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "task" && typeof fetchClientData === "function") {
        // await fetchClientData();
        window.location.reload();
      }
      if (apiType === "product" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "vendor" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "sales" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "purchase" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "device" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "dealer" && typeof fetchClientData === "function") {
        await fetchClientData();
      }

      if (apiType === "customer" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "payment" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "bill_type" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "product_type" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "code_type" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "lead" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "leadSource" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "leadStatus" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "taskStatus" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "quotationStatus" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "lead_task" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "quotation" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "employee" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "role" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "roleassign" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "taskDiscussionStatus" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "branch" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "product" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
      if (apiType === "typeOfWork" && typeof fetchClientData === "function") {
        await fetchClientData();
      }
    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error("Failed to delete the item.");
    }
  };

  return (
    <div>
      {/* Delete Button */}
      <div className="relative inline-block">
        <button
          className="my-anchor-delete relative group cursor-pointer bg-red-400 rounded-md p-1 flex items-center w-full sm:w-auto"
          onClick={() => openDialog(id_crypt)}
        >
          <TrashIcon className="h-5 w-5 text-white" />
          <Tooltip
            anchorSelect=".my-anchor-delete"
            place="top"
            className="text-xs"
            style={{ fontSize: "12px", padding: "0.3rem" }}
          >
            Delete
          </Tooltip>
        </button>
      </div>

      {isDialogOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
            {/* Modal Header - Responsive Design */}

            <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
              <div className="flex flex-col sm:flex-row items-center sm:space-x-4">
                {/* Icon (Centered in Small Screens) */}
                <span className="flex items-center justify-center p-2 rounded-full bg-red-100">
                  <ExclamationCircleIcon className="h-6 w-6 text-red-600" />
                </span>

                {/* Text (Stacked in Small Screens) */}
                <div className="text-center sm:text-left mt-3 sm:mt-0">
                  <h2 className="text-lg font-bold text-gray-800">
                    Delete Confirmation
                  </h2>
                  <p className="text-gray-600">
                    Are you sure you want to delete this?
                  </p>
                </div>
              </div>

              {/* Close Icon (Hidden in Small Devices) */}
              {/* <div className="hidden sm:block text-right">
            <XMarkIcon
              className="h-6 w-6 text-red-600 cursor-pointer border rounded p-1 inline-block"
              onClick={closeDialog}
            />
          </div> */}
            </div>

            {/* Buttons - Always at the Bottom */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
              <button
                onClick={closeDialog}
                className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteForTask}
                className="w-full sm:w-auto px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {dialogForTransaction && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 z-50">
          <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[50%] max-w-[600px] grid gap-6">
            {/* Modal Header - Responsive Design */}
            <div className="grid grid-cols-1 sm:grid-cols-2 items-center">
              <div className="flex flex-col sm:flex-row items-center sm:space-x-4">
                {/* Icon (Centered in Small Screens) */}
                <span className="flex items-center justify-center p-2 rounded-full bg-red-100">
                  <ExclamationCircleIcon className="h-6 w-6 text-red-600" />
                </span>

                {/* Text (Stacked in Small Screens) */}
                <div className="text-center grid grid-cols-1 sm:text-left mt-3 sm:mt-0 w-full">
                  <h2 className="text-lg font-bold text-gray-800">
                    Delete Confirmation
                  </h2>
                  <div className="w-full overflow-x-auto sm:overflow-visible mt-4 sm:mt-2">
                    {errorMessage}
                  </div>
                </div>
              </div>
            </div>

            {/* Buttons - Always at the Bottom */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:flex sm:justify-end">
              <button
                onClick={() => setDialogForTransaction(false)}
                className="w-full sm:w-auto px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                onClick={() => setDialogForTransaction(false)}
                className="w-full sm:w-auto px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeleteConfirmation;
